export default "__VITE_ASSET__Be7a35WD__"